import { useCallback, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

import { useStateFromSearchParams } from '@/hooks/useStateFromSearchParams';

export const useRepetitionSidePane = (
  setSearchParams: ReturnType<typeof useSearchParams>[1]
) => {
  const [, setActiveRun] = useStateFromSearchParams(
    'activeSession',
    null,
    setSearchParams
  );

  const [repetitionsSidePaneInfoRaw, setRepetitionsSidePaneInfoRaw] =
    useStateFromSearchParams('repsDetail', null, setSearchParams);
  const repetitionsSidePaneItems = useMemo(() => {
    return repetitionsSidePaneInfoRaw
      ? repetitionsSidePaneInfoRaw.split(',').filter(Boolean)
      : [];
  }, [repetitionsSidePaneInfoRaw]);

  const repetitionsSidePaneInfo = useMemo(() => {
    if (repetitionsSidePaneItems.length !== 2) {
      return null;
    }
    return {
      session: repetitionsSidePaneItems[0],
      example: repetitionsSidePaneItems[1],
    };
  }, [repetitionsSidePaneItems]);

  const setRepetitionsSidePaneInfo = useCallback(
    (session: string | null, example: string | null, run: string | null) => {
      setRepetitionsSidePaneInfoRaw(
        session && example ? `${session},${example}` : null
      );
      setActiveRun(run ?? null);
    },
    [setRepetitionsSidePaneInfoRaw, setActiveRun]
  );

  return {
    repetitionsSidePaneInfo,
    setRepetitionsSidePaneInfo,
  };
};
